let form = {

    init: function () {
        const formSelector = 'form';
        form.elements = document.querySelectorAll(formSelector);
        form.attemptActionIfNotEmpty(form.ready);

        window.addEventListener('load', () => {
            form.attemptActionIfNotEmpty(form.loaded);
        });
    },

    attemptActionIfNotEmpty: function (action) {
        if (form.elements && form.elements.length > 0) {
            action();
        }
    },

    ready: function () {
        const uploadFields = document.querySelectorAll('input[type="file"]');

        uploadFields.forEach((field) => {
            field.addEventListener('change', (event) => {
                const fileName = event.target.files[0].name;
                const label = event.target.parentElement;
                label.dataset.text = fileName;

                if (fileName) {
                    label.classList.add('has-file');

                    //add extension of file to data attribute
                    label.dataset.filetype = fileName.split('.').pop();
                }
            });
        });
    },

    loaded: function () {

    }
};

export default form.init();

